import NavigationButtons from './NavigationButtons.component';

export default NavigationButtons;
